import AccordionLocaleSwitcher from "./accordion";
import MenubarLocaleSwitcher from "./menubar";

export { MenubarLocaleSwitcher, AccordionLocaleSwitcher };
